import { Box, SxProps, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

export interface IFeatureLabelProps {
  label: string
  value: string
  sx?: SxProps
}

export const FeatureLabel: React.FC<IFeatureLabelProps> = ({
  label,
  value,
  sx = {},
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiDescriptionList`]?.styleOverrides || {}
  const { root, labelText, contentText } = styleOverrides

  return (
    <Box sx={deepmerge(root, sx)} className="VuiDescriptionList-root">
      <Typography
        variant="h6"
        className="VuiDescriptionList-labelText"
        sx={labelText}
      >
        {label}
      </Typography>
      <Typography
        variant="subtitle2"
        className="VuiDescriptionList-contentText"
        sx={contentText}
      >
        {value}
      </Typography>
    </Box>
  )
}
